import React from "react";
import Modal from "./Modal";
import styles from "./ProfilePicRemoveModal.module.scss";

const ProfilePicRemoveModal = ({showPopupModal, setShowPopupModal, handleRemoveImage}) => {
  return (
    <Modal
      width="22rem"
      modalOpen={showPopupModal}
      onClose={() => setShowPopupModal(false)}
      heading="Remove profile picture"
    >
      <div className={styles.popupListDetails}>
        <p>
          Are you sure? <br /> you want to remove the Profile
        </p>
        <div className={styles.btnSection}>
          <button
            className={styles.cancel}
            onClick={() => setShowPopupModal(false)}
          >
            No
          </button>
          <button className={styles.shortlist} onClick={handleRemoveImage}>
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProfilePicRemoveModal;
